import { Component, Input, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Guid } from 'guid-typescript';
import {IFlowChartDataService} from '../../../services/flow-chart-data.service';

@Component({
    standalone: false,
    selector: 'particle-flow-chart-page-view',
  templateUrl: './flow-chart-page-view.component.html',
  styleUrls: ['./flow-chart-page-view.component.scss']
})
export class FlowChartPageViewComponent implements OnInit {
  selectedFieldSectionIndex: number;
  @Input() sourceType: string;
  @Input() flowChartDataService: IFlowChartDataService;
  constructor() { }
  @Input() section: any;
  ngOnInit() {
    this.onTabIndexChange(0);
  }
  onTabIndexChange($event) {
    this.selectedFieldSectionIndex = $event;

  }
  onValueChanged(event) {


  }
  onPageChange(event: PageEvent) {
    this.selectedFieldSectionIndex = event.pageIndex;
  }
}
